import {Config} from "../config/Config"


export class Api {

    /**
     *  ApiRequest
     *
     *  @param {string} action
     *  @param {*} data
     *  @param {File[]} files
     *  @param {boolean} json
     *  @param {?string} url
     */
    static async request(action, { data=null, files=[], json=true, url=null }={}){
        const formData = new FormData()

        // Добавляем данные
        formData.append('action', action)
        formData.append('data', JSON.stringify(data))

        // Добавляем файлы в FormData
        files.forEach( file => formData.append('files[]', file) )

        // Отправляем данные на сервер
        url = url ?? Config.apiUrl
        const response = await fetch( url, { method: 'POST', body: formData })

        if (!response.ok) {
            console.error('Ошибка при отправке файлов и данных:', response)
            throw new Error( String(response.status) )
        }
        return json
            ? await response.json()
            : await response.text()
    }

}

